<template>
  <div>
    <the-nav-bar :title="$t('related.name')" />
    <div class="body-wrapper">
      <div class="loading row-center" v-if="loadStatus === 'loading'">
        <md-activity-indicator color="currentColor" vertical>
          Loading...
        </md-activity-indicator>
      </div>
      <div
        class="empty col-center"
        v-else-if="loadStatus === 'failed' || !list.length"
      >
        <img src="@/images/record-empty.svg" alt="Not Found" class="img" />
        <span class="text">{{ $t('related.empty') }}</span>
      </div>
      <div class="list-wrapper" v-else>
        <exchange-item
          v-for="item in list"
          :key="item.id"
          :data="item"
          :show-btn="true"
          @btn-click="goDetail(item.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import exchangeItem from '@/components/exchange-item';
import { ActivityIndicator, Toast } from 'mand-mobile';
import getAdsList from '@/api/get-ads-list';
import { mapState } from 'vuex';
export default {
  name: '',
  components: {
    TheNavBar,
    exchangeItem,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      id: '',
      loadStatus: 'loading',
      list: [],
    };
  },
  computed: {
    ...mapState({
      settings: state => state.settings,
    }),
  },
  created() {
    const { id } = this.$route.query;
    if (!id) {
      Toast.failed(this.$t('error.para'));
      this.$router.go(-1);
      return;
    }
    this.id = id;
    this.loadStatus = 'loading';
    let p1 = Promise.resolve();
    let p2 = this.loadData()
      .then(() => {
        this.loadStatus = 'success';
      })
      .catch(err => {
        this.loadStatus = 'failed';
        return Promise.reject(err);
      });
    if (this.settings.isSettingsLoaded) {
      p1 = this.$store.dispatch('updateSettings');
    }
    Promise.all([p1, p2]).catch(err => {
      Toast.failed(err.message);
    });
  },
  methods: {
    loadData() {
      return getAdsList(1, 40, null, null, null, null, null, 0, this.id).then(
        ({ data: d }) => {
          if (Array.isArray(d)) {
            d.forEach(item => {
              const obj = {
                id: item.id, // 订单id
                type: item.type,
                title: item.title,
                description: item.description,
                // price
                price: item.price,
                minPrice: item.minPrice,
                maxPrice: item.maxPrice,
                isCheck: !!+item.isCheck,
                assetId: item.assetId,
                legalCurrencyId: item.legalCurrencyId,
                locationId: item.locationId,
                payMethodIds: Array.isArray(item.payMethodIds)
                  ? item.payMethodIds
                  : [],
                user: {
                  nickname: item.user.nickname,
                  avatarUrl: item.user.avatarUrl,
                  createdAt: item.user.createdAt,
                  multisigOrderCount: item.user.multisigOrderCount,
                  hasCertified: !!+item.user.isLandun,
                  hasVideo: !!+item.user.hasVideo,
                  hasVerified: !!item.user.trueName,
                  orderSuccessRank: item.user.orderSuccessRank,
                  rateRank: item.user.rateRank,
                  in5minRate: item.user.in5minRate,
                },
                zone: item.zone,
                ontimeStart: item.ontimeStart,
                ontimeEnd: item.ontimeEnd,
              };
              Object.freeze(obj);
              this.list.push(obj);
            });
          }
        },
      );
    },
    goDetail(id) {
      this.$router.push({
        path: '/exchange/takeOrder',
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.loading, .empty {
  min-height: 40vw;
  color: color-primary;

  .img {
    margin: 4.8vw auto;
    width: 28vw;
  }

  .text {
    color: color-text-caption;
  }

  >>> .md-activity-indicator-svg {
    width: 8vw !important;
    height: 8vw !important;
  }
}

.body-wrapper {
  padding: 4.8vw 4.8vw 60vw;
}
</style>
